module.exports = __webpack_public_path__ + "static/banner-logo-55287722a72c178be4ff9a9adf3d85de.png";